import React from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { View, Text, Icon } from '..';
import './styles.scss';

const UploadItem: React.FC<UploadItemProps> = ({ file }) => {
  const isUploadFailed = file?.status === 0 && file?.progress === 100;
  return (
    <View className={'cmp-upload-item'}>
      <View className={`cmp-upload-item__progress-bar ${isUploadFailed ? 'cmp-upload-item__error-bar' : ''}`}>
        <div style={{ width: `${file?.progress}%` }} />
      </View>
      <View isRow justify="space-between" align="center" className="mb-8">
        <Text className={'cmp-upload-item__name'}>{file?.file?.name}</Text>
        {isUploadFailed ? (
          <p data-tooltip={file.error} className="has-tooltip-left">
            <Icon key={`failed-file-column-info-${file.id}`} name="ic_info" className="grid-rejected-icon" />
          </p>
        ) : (
          <Text className={'cmp-upload-item__percentage'}>{`${file?.progress}%`}</Text>
        )}
      </View>
    </View>
  );
};

export type UploadItemProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    file: any;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UploadItem);
